export const EQUIFAX_KYC_STATUS = {
  PASS: 1,
  FAIL: 2,
};

export const INVESTOR_TYPE = {
  ACCREDITED_INVESTOR: 1,
  ELIGIBLE_INVESTOR: 2,
  RETAIL_INVESTOR: 3,
};

export const INVESTOR_TYPE_TO_TEXT = {
  1: 'Accredited Investor',
  2: 'Eligible Investor',
  3: 'Retail Investor',
};

export const DOCUSIGN_ENVELOPE_STATUSES = {
  not_sent: 'Not Sent',
  completed: 'Completed',
  created: 'Created',
  declined: 'Declined',
  deleted: 'Deleted',
  delivered: 'Delivered',
  sent: 'Sent',
  signed: 'Signed',
  transfercompleted: 'Transfer Completed',
  voided: 'Voided',
};

export const EMD_ASSESSMENT_STATUS = {
  PENDING: 1,
  CANCELLED: 2,
  COMPLETED: 3,
  FAILED: 4,
};

export const EMD_ASSESSMENT_STATUS_TO_TEXT = {
  1: 'Pending',
  2: 'Cancelled',
  3: 'Completed',
  4: 'Failed',
};

export const TRANSACTION_STATUS = {
  STATUS: 0,
  PAYMENT_PENDING: 1,
  PAYMENT_RECEIVED: 2,
  PROMO_PENDING: 3, // Used to mark transactions that are added as promos before we get customer money.
  SECONDARY_MARKETPLACE_SALE: 4,
  SECONDARY_MARKETPLACE_SOLD_SHARES: 5,
  ZUMRAILS_PAYMENT_FAILED: 6,
  ZUMRAILS_PAYMENT_RECEIVED: 7,
  PAYMENT_REFUNDED: 8,
  PAYMENT_MOVED: 9,
  PAYMENT_REFUND_PENDING: 10,
};

export const TRANSACTION_TABLE = {
  'Transaction ID': 'transactions.id_uip',
  'First Name': 'first_name_ip1',
  'Last Name': 'last_name_ip1',
  Email: 'transactions.fk_email',
  Amount: 'investmentAmount',
  Status: 'transaction_status',
  'Address Area': 'address_area',
  Address: 'address',
  City: 'city',
};

export const USERS_TABLE_SEARCH_OPTIONS = {
  Email: 'users.email',
  'First Name': 'user_investment_profiles.first_name_ip1',
  'Last Name': 'user_investment_profiles.last_name_ip1',
  Phone: 'user_investment_profiles.phone_ip1',
};

export const transStatus = [
  'Status',
  'Payment Pending',
  'Payment Received',
  'Promo Pending',
  'Secondary MarketPlace Sale',
  'Secondary MarketPlace Sold Shares',
  'ZumRails Payment Failed',
  'ZumRails Payment Received',
  'Payment Refunded',
  'Payment Moved',
  'Pending Refund',
];

export const paymentModes = ['NA', 'Interac', 'Wire'];

export const TransStatusTotagColor = new Map();
TransStatusTotagColor.set(TRANSACTION_STATUS.PAYMENT_PENDING, 'warning');
TransStatusTotagColor.set(TRANSACTION_STATUS.PAYMENT_RECEIVED, 'success');
TransStatusTotagColor.set(TRANSACTION_STATUS.PROMO_PENDING, 'secondary');
TransStatusTotagColor.set(
  TRANSACTION_STATUS.SECONDARY_MARKETPLACE_SALE,
  'dark'
);
TransStatusTotagColor.set(
  TRANSACTION_STATUS.SECONDARY_MARKETPLACE_SOLD_SHARES,
  'dark'
);
TransStatusTotagColor.set(TRANSACTION_STATUS.ZUMRAILS_PAYMENT_FAILED, 'danger');
TransStatusTotagColor.set(
  TRANSACTION_STATUS.ZUMRAILS_PAYMENT_RECEIVED,
  'success'
);
TransStatusTotagColor.set(TRANSACTION_STATUS.PAYMENT_REFUNDED, 'info');
TransStatusTotagColor.set(TRANSACTION_STATUS.PAYMENT_REFUND_PENDING, 'warning');
TransStatusTotagColor.set(TRANSACTION_STATUS.PAYMENT_MOVED, 'primary');

export const USER_ROLES = {
  BP_USER: 1,
  EMD_PARTNER: 2,
  BP_ADMIN: 3,
  BP_MARKETING_USER: 4,
  ISSUER: 5,
  SPONSOR: 6,
};

export const PROPERTY_TYPES = {
  CONDOMINIUM: 1,
  SEMI_DETACHED: 2,
  ROW_HOUSE: 3,
  STACKED_TOWNHOME: 4,
  MODULAR_HOME: 5,
  DETACHED_HOUSE: 6,
  TOWN_HOUSE: 7,
  SINGLE_RESIDENCE: 8,
  COMMERCIAL_CONDO: 9,
  MULTI_FAMILY_RESIDENCE: 10,
  INDUSTRIAL: 11,
  CAMPGROUND: 12,
  VACATION_HOMES: 13,
  OTHER: 0,
};

export const PROPERTY_STATUS = {
  DEAL_NOT_LIVE: 0,
  OBSOLETE: 1, // Will not be displayed to the user
  SOLD_OUT: 2, // Can't invest anymore
  CLOSED: 3, // Temporarily closed.
  COMING_SOON: 8, // Will be available soon.
  ACCEPTING_RESALE: 5, // Sold out can do re-sale
  SHARES_AVAILABLE: 5, // Sold out can do re-sale
  PROPERTY_LIVE: 6, // Can invest now
  OPEN_FOR_RESERVATION: 7, // Open for reservation
  FULL_PROPERTY_LIVE: 9, // Live full konfidis property
  DEAL_CANCELLED: 10,
  EXITED: 11,
};

export const PROPERTY_TABLE = {
  'Property ID': 'id_properties_base',
  Type: 'type',
  'Address Area': 'address_area',
  Address: 'address',
  City: 'city',
  'Purchase Price': 'purchase_price',
  'Deal Live': 'property_live',
  'Property Status': 'property_status',
};

export const SMS_CAMPAIGN_TABLE = {
  'CAMPAIGN ID': 'id',
  'PHONE NUMBER': 'phone_number',
  EMAIL: 'email_address',
  'FIRST NAME': 'first_name',
  'LAST NAME': 'last_name',
  STATUS: 'status',
  'OPT-OUT': 'unsubscribed',
  DELIVERED: 'delivered_count',
  FAILED: 'failed_count',
};
export const USER_LIST_TABLE = {
  'First Name': 'first_name_ip1  ',
  'Last Name': 'last_name_ip1',
  Email: 'fk_email_ip1',
  'Phone Number': 'phone_ip1',
};

export const DOCUSIGN_FOLDER_OPTIONS = {
  All: 'all',
  Drafts: 'drafts',
  Completed: 'completed',
  'Out For Signature': 'out_for_signature',
  // "Awaiting my Signature": 'awaiting_my_signature'
};

export const PROPERTY_UPDATE_TABLE = {
  'Deal Name': 'address',
  Email: 'created_by',
  'Update Type': 'update_type',
  'Update Date': 'update_date',
  'Creation Date': 'created_at',
  Content: 'content',
};

export const PROPERTY_UPDATE_TYPES = [
  'Deal Updates',
  'Property Updates',
  'Investor Relation Updates',
  'Market Updates',
  'Upcoming',
];

export const ACCOUNT_OWNERSHIP = {
  INDIVIDUAL_USER: 1,
  CORPORATE_USER: 2,
};

export const TRANSACTION_CONTRACT_TYPE = {
  PRIMARY_MARKETPLACE: 1,
  SECONDARY_MARKETPLACE: 2,
};

export const BannerCategories = {
  CORE: 0,
  CORE_PLUS: 1,
  VALUE_ADD: 2,
  PRECONSTRUCTION: 3,
  REDEVELOPMENT: 4,
};

export const MONEY_SENT_ENUM = {
  SENT: 1,
  NOT_SENT: 2,
};

export const TRANSACTION_DEAL_STATUS = {
  REFUND_REQUESTED: 1,
  TRANSFER_REQUESTED: 2,
  REFUND_COMPLETED: 3,
  TRANSFER_COMPLETED: 4,
};

export const MARTIAL_STATUS = [undefined, 'Single', 'Married', 'Other'];

export const INVESTMENT_TYPE = {
  REAL_ESTATE: 1,
  PRIVATE_CREDIT: 2,
};

export const PAYMENT_MODE = {
  INTERAC: 1,
  WIRE_TRANSFER: 2,
  ONLINE: 3,
  REGISTERED_FUNDS: 4,
};
